import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import SearchBar from "../../Component/SearchBar/SearchBar";
import NumberOfOrder from "../../Component/NumberOfOrder/NumberOfOrder";
import SendToBasket from "../../Component/SendToBasket/SendToBasket";
import Style from "./Product.module.css";
import { categoryApi } from "../../Api/ClientServices";
import StoreMenuSupermarket from "../../Component/storeMenuSupermarket/StoreMenuSupermarket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { categoryApiDependSupplier } from "../../Api/BarestServices";
import { separate } from "../../Seprate/Seprate";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { errorToast } from "../../Toast/Toast";

const Product = (props) => {
  const [data, setData] = useState([]);
  const [productMenu, setProductMenu] = useState();
  const [filter, setFilter] = useState("");

  const path = window.location.pathname.split("/");
  useEffect(() => {
    if (path[3] === undefined) {
      category(1);
    } else {
      category(2, path[3]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const category = async (value, id) => {
    if (value === 1) {
      Update();
    } else {
      categoryApiDependSupplier(
        props.location.state.category_english,
        id,
        (succ, res) => {
          if (succ) {
            if (res.status === 0) {
              errorToast("مشکلی پیش آمده است");
            } else {
              setProductMenu(res.categories);
              setData(res.products);
            }
          } else {
            console.error(res);
          }
        }
      );
    }
  };
  const filterProduct = async (categoryName) => {
    if (path[3] === undefined) {
      categoryApi(categoryName, (succ,res) => {
        if (succ) {
          if (res.status === 0) {
            setData(res.products);
          } else {
            errorToast("مشکلی پیش آمده است");
          }
        } else {
          console.error(res);
        }
      });
    } else {
      categoryApiDependSupplier(categoryName, path[3], (succ, res) => {
        if (succ) {
          if (res.status === 1) {
            errorToast("مشکلی پیش آمده است");
          } else {
            setData(res.products);
          }
        } else {
          console.error(res);
        }
      });
    }
  };
  const Update = async () => {
    categoryApi(props.location.state.category_english, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setProductMenu(res.categories);
          setData(res.products);
        }
      } else {
        console.error(res);
      }
    });
  };

  let loading = null;

  if (data === undefined) {
    loading = (
      <div>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    loading = (
      <ul className={Style.productsHolder}>
        {data &&
          data
            .filter((value) => {
              if (value.filter === "") {
                return value;
              } else if (
                value.name.includes(filter) ||
                value.supplier.includes(filter)
              ) {
                return value;
              }
              return false;
            })
            .map((item) =>
              item.count === "0" ? null : (
                <li key={item.id} className={Style.productItem}>
                  <Link
                    to={{
                      pathname: `/product/${item.id}/${
                        path[3] === undefined ? "" : path[3]
                      }`,
                      state: item.id,
                    }}
                    className={Style.ATag}
                  >
                    <div className={Style.picHolder}>
                      <img
                        src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
                        alt={item.name}
                      />
                    </div>
                  </Link>
                  <div className={Style.textHolder}>
                    <h2 className={Style.productName}>{item.name}</h2>
                    <h3 className={Style.supName}>
                      <FontAwesomeIcon
                        className={Style.shopIcon}
                        icon={faStore}
                      />
                      {item.supplier}
                    </h3>
                    <div className={Style.priceHolder}>
                      <h3
                        className={
                          item.off_price === "0" ? Style.price : Style.noPrice
                        }
                      >
                        <span>{separate(item.price)}</span>تومان
                      </h3>
                      <h3
                        className={
                          item.off_price === "0"
                            ? Style.noOffprice
                            : Style.offprice
                        }
                      >
                        <span>{separate(item.off_price)}</span>تومان
                      </h3>
                    </div>
                  </div>
                  <div className={Style.counter}>
                    {path[3] === undefined ? (
                      <NumberOfOrder
                        dataUpdate={() => category(1)}
                        supId={item.supplier_id}
                        data={item}
                      />
                    ) : (
                      <NumberOfOrder
                        dataUpdate={() => category(2, path[3])}
                        supId={item.supplier_id}
                        data={item}
                      />
                    )}
                  </div>
                </li>
              )
            )}
      </ul>
    );
  }
  return (
    <div>
      <BurgerMenuTitle title={props.location.state.category_persian} />
      <br />
      <br />
      <SearchBar filteritem={filter} setfilter={setFilter} />
      <br />
      <br />
      <StoreMenuSupermarket
        filterProduct={filterProduct}
        products={productMenu}
      />
      <br />
      {loading}
      <br />
      <br />
      <br />
      <br />
      <br />
      <SendToBasket />
    </div>
  );
};
export default Product;
